// eslint-disable-next-line no-unused-vars
export function loadComments({ commit, rootGetters }) {
  const comments = require("@/assets/comments.json");
  commit("SET_COMMENTS", comments);
}
